/*
 * BIPA consent text + version for the AI Headshot capture mode.
 *
 * SINGLE SOURCE OF TRUTH on this surface for the biometric-consent disclosure
 * shown to operators in the dashboard. The version string is a CROSS-SURFACE
 * CONTRACT whose authoritative home is rails'
 * `ConsentRecord::BIPA_CONSENT_TEXT_VERSION` (movebooth-rails #1254): the
 * AI-headshot consent gate 422s (`consent_version_stale`, carrying
 * `current_consent_text_version`) on any other value, and iOS shows the same
 * text/version to guests at capture time. The scheme is date-stamped with an
 * explicit `.draft-N` marker while the RM-040 legal-approved text is pending;
 * legal sign-off bumps it (e.g. `2026-09-XX.1`). Any text change MUST bump
 * the version on rails + here + iOS in the same rollout.
 */

export const BIPA_CONSENT_TEXT_VERSION = "2026-08-21.draft-1";

export const BIPA_CONSENT_TEXT = `Movebooth's AI Headshot mode collects photographs of your face and processes facial geometry from them — biometric information under laws such as the Illinois Biometric Information Privacy Act (BIPA) — solely to generate the stylized professional headshots you request.

By typing your full name and affirming below, you provide your written consent for Movebooth to collect and process your photographs, and to share them with its image-generation service provider, for this purpose only. Your reference photos and the biometric information derived from them are used only to create your headshots, are never sold or used for advertising, and are permanently deleted once your headshots have been generated and delivered — and in any event within 3 years of your last interaction with Movebooth, whichever comes first.

You may decline. The booth's standard (non-AI) capture modes remain available without any biometric processing.`;
